import { render, staticRenderFns } from "./JcRange.vue?vue&type=template&id=2226af28&scoped=true"
import script from "./JcRange.vue?vue&type=script&lang=js"
export * from "./JcRange.vue?vue&type=script&lang=js"
import style0 from "./JcRange.vue?vue&type=style&index=0&id=2226af28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226af28",
  null
  
)

export default component.exports